import { useCallback, useState } from "react";
import { PendingActivity } from "./PendingActivities";
import { searchInvitedBusiness } from "services/SauceService";
import InvitationsTable from "../invitations-table";
import "./PendingActivities.scss";

interface InvitationsTabProps {
  loading?: boolean;
  showCreatorInfo?: boolean;
  onCancel?: (invite: PendingActivity) => void;
  isActive?: boolean;
  onRefresh?: () => void;
  creatorId?: string;
}

const InvitationsTab: React.FC<InvitationsTabProps> = ({
  loading: externalLoading,
  showCreatorInfo,
  onCancel,
  isActive = false,
  onRefresh,
  creatorId,
}) => {
  const [localLoading, setLocalLoading] = useState<boolean>(false);

  const fetchInvitations = useCallback(
    async (limit: number, offset: number) => {
      const businessId = localStorage.getItem("businessId");
      if (!businessId) {
        return { data: [], total: 0 };
      }

      try {
        setLocalLoading(true);
        const response: any = await searchInvitedBusiness({
          businessId,
          creatorId: creatorId,
          limit,
          offset,
        });

        return {
          data: response?.data || [],
          total: response?.pagination?.total || 0,
        };
      } catch (err) {
        console.error("Failed to fetch invitations", err);
        return { data: [], total: 0 };
      } finally {
        setLocalLoading(false);
      }
    },
    [creatorId]
  );

  const handleCancel = useCallback(
    async (invite: PendingActivity) => {
      await onCancel?.(invite);
      onRefresh?.();
    },
    [onCancel, onRefresh]
  );

  if (!isActive) {
    return null;
  }

  return (
    <InvitationsTable
      fetch={fetchInvitations}
      loading={externalLoading || localLoading}
      showCreatorInfo={showCreatorInfo}
      onCancel={handleCancel}
    />
  );
};

export default InvitationsTab;
